export const FINALIZING_STIPS_STATUSES: string[] = ['QA'];
